import React from "react";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

const PageTitle = ({title = "", image = null}) => {

  return (
    <Box
      className="animate__animated animate__fadeIn"
      sx={{
        position: "relative",
        backgroundImage: `url("${image}")`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        color: "white",
        textAlign: "center",
        overflow: "hidden", // Ensures the dim layer stays inside the box
        display:"flex",
      }}
    >
      <Box src={`${image}`} component={"img"} sx={{width:"100%"}}>

      </Box>  
    
    </Box>
  );
};

export default PageTitle;
